import { createContext } from "react";

const DF_OT0050Context = createContext();

export { DF_OT0050Context };
